<template>
  <div>
    <div>
      <el-dialog
        :visible.sync="centerDialogVisibleprimaryMedia"
        width="45%"
        center
      >
        <template slot="title"
          ><h3 class="fsize16 Add mb-0 Products text-white">
            Upload
          </h3></template
        >

        <div class="p-3">
          <el-upload
            class="upload-demo"
            drag
            action="https://jsonplaceholder.typicode.com/posts/"
            :on-success="handleUploadSuccess"
            :before-upload="beforeUpload"
            multiple
          >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">
              Drop file here or <em>click to upload</em>
            </div>
            <div class="el-upload__tip" slot="tip">
              jpg/png files with a size less than 500kb
            </div>
          </el-upload>

          <vs-tabs class="mt-8">
            <vs-tab label="Admin Images">
              <div
                class="grid grid-cols-3 items-center gap-4 mt-4 heigh-500 pr-4"
              >
                <div
                  class="img_wrap w-full"
                  v-for="(item, index) in mediaCollection"
                  :key="('item-', +index)"
                  @click="LogoClick(item)"
                  v-show="item.type != 'video'"
                >
                  <div class="w-full">
                    <img
                      :src="url + '/' + item.link"
                      alt="image"
                      class="w-full object-cover rounded-4px tab-imgh cursor-pointer"
                    />
                  </div>

                  <div class="previewselect" v-if="LogoMedia._id == item._id">
                    <feather-icon
                      icon="CheckIcon"
                      svgClasses="w-8 h-8"
                      class="text-success font-semibold"
                    />
                  </div>
                </div>
              </div>
            </vs-tab>
            <vs-tab label="AI Search">
              <div class="mt-4">
                <div class="relative">
                  <el-input placeholder="Search" v-model="search"></el-input>
                  <div
                    class="absolute top-0 mr-2 mt-2 bg-white cursor-pointer right-0"
                    @click="RequestToPixabay()"
                  >
                    <feather-icon icon="SearchIcon" SvgClasses="w-4 h-4" />
                  </div>
                </div>
                <h3 class="fsize16 Add mb-0 Products">
                  Ai Credits: {{ ailimit }}
                </h3>
                <div
                  class="grid grid-cols-3 items-center gap-4 mt-4 heigh-500 pr-4 onlineimage"
                  v-if="OnlineImages.length !== 0"
                >
                  <div
                    v-for="(item, index) in OnlineImages"
                    :key="('item-', +index)"
                    @click="ClickonPixabay(item.largeImageURL)"
                  >
                    <div class="relative bg-secondary">
                      <img
                        :src="item.largeImageURL"
                        alt="image"
                        class="w-full object-cover rounded-4px h-full cursor-pointer"
                      />
                      <div
                        v-if="OnlineSelectedImages.includes(item.largeImageURL)"
                        class="previewselect"
                      >
                        <feather-icon
                          icon="CheckIcon"
                          class="text-success flex font-semibold"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div v-else>No data found</div>
                <div class="flex gap-4 justify-start">
                  <vs-button
                    type="primary"
                    class="bg-primary cursor-pointer mt-3 px-8 py-3"
                    @click="nextStep"
                  >
                    Save</vs-button
                  >
                </div>
              </div>
            </vs-tab>
          </vs-tabs>
        </div>
      </el-dialog>
    </div>
    <div>
      <el-dialog
        :visible.sync="centerDialogVisibleprimaryImage"
        width="45%"
        center
      >
        <template slot="title"
          ><h3 class="fsize16 Add mb-0 Products text-white">
            Upload
          </h3></template
        >

        <div class="p-3">
          <el-upload
            class="upload-demo"
            drag
            action="https://jsonplaceholder.typicode.com/posts/"
            :on-success="handleUploadSuccess"
            :before-upload="beforeUpload"
            multiple
          >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">
              Drop file here or <em>click to upload</em>
            </div>
            <div class="el-upload__tip" slot="tip">
              jpg/png files with a size less than 500kb
            </div>
          </el-upload>
          <vs-tabs class="mt-8">
            <vs-tab label="Admin Images">
              <div
                class="grid grid-cols-3 items-center gap-4 mt-4 heigh-500 pr-"
              >
                <div
                  class="img_wrap w-full"
                  v-for="(item, index) in mediaCollection"
                  :key="('item-', +index)"
                  @click="ImageClick(item)"
                  v-show="item.type != 'video'"
                >
                  <div class="w-full">
                    <img
                      :src="url + '/' + item.link"
                      alt="image"
                      class="w-full object-cover rounded-4px tab-imgh cursor-pointer"
                    />
                  </div>

                  <div class="previewselect" v-if="ImageMedia._id == item._id">
                    <feather-icon
                      icon="CheckIcon"
                      svgClasses="w-8 h-8"
                      class="text-success font-semibold"
                    />
                  </div>
                </div>
              </div>
            </vs-tab>
            <vs-tab label="AI Generate">
              <div class="mt-4">
                <div class="relative">
                  <el-input placeholder="Search" v-model="search"></el-input>
                  <div
                    class="absolute top-0 mr-2 mt-2 bg-white cursor-pointer right-0"
                    @click="RequestToPixabay()"
                  >
                    <feather-icon icon="SearchIcon" SvgClasses="w-4 h-4" />
                  </div>
                </div>
                <h3 class="fsize16 Add mb-0 Products">
                  Ai Credits: {{ ailimit }}
                </h3>

                <div
                  class="grid grid-cols-3 items-center gap-4 mt-4 heigh-500 pr-4"
                  v-if="OnlineImages.length !== 0"
                >
                  <div
                    v-for="(item, index) in OnlineImages"
                    :key="('item-', +index)"
                    @click="ClickonPixabay(item.largeImageURL)"
                  >
                    <div class="relative bg-secondary">
                      <img
                        :src="item.largeImageURL"
                        alt="image"
                        class="w-full object-cover rounded-4px h-full cursor-pointer"
                      />
                      <div
                        v-if="OnlineSelectedImages.includes(item.largeImageURL)"
                        class="previewselect"
                      >
                        <feather-icon
                          icon="CheckIcon"
                          class="text-success flex font-semibold"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div v-else>No data found</div>
                <div class="flex gap-4 justify-start">
                  <vs-button
                    type="primary"
                    class="bg-primary cursor-pointer mt-3 px-8 py-3"
                    @click="nextStep"
                  >
                    Save</vs-button
                  >
                </div>
              </div>
            </vs-tab>
          </vs-tabs>
        </div>
      </el-dialog>
    </div>

    <el-dialog
      title=""
      :visible.sync="isShowContentEdit"
      width="70%"
      center
      class="height-doalog"
    >
      <template slot="title"
        ><h3 class="fsize16 Add mb-0 Products text-white">
          Add Details
        </h3></template
      >
      <div class="mt-4 p-8">
        <div v-if="currentStep === 1" class="height-left">
          <div class="flex items-center gap-2">
            <h2 class="font-semibold mb-0 text-dark text-xl">Step 1</h2>
            <p class="fsize10 bg-light-green my-0 py-2 rounded-full px-3">
              Ai Credits: {{ ailimit }}
            </p>
          </div>

          <div class="mt-8">
            <div class="flex items-center gap-2">
              <div class="w-10/12">
                <el-input
                  v-model="search"
                  placeholder="Search format example Yellow+flower if natural language is used Ai will be used"
                  class="rounded-xl"
                />
              </div>
              <div class="w-2/12 flex justify-end">
                <vs-button
                  type="primary"
                  class="bg-primary cursor-pointer px-8 py-3"
                  @click="RequestToPixabay()"
                >
                  Search</vs-button
                >
              </div>
            </div>

            <div
              class="justify-center grid grid-cols-4 items-start gap-8 mt-6 heigh-450 pr-4"
              v-if="OnlineImages.length !== 0"
            >
              <div
                v-for="(item, index) in OnlineImages"
                :key="('item-', +index)"
                @click="ClickonPixabay(item.largeImageURL)"
              >
                <div class="relative">
                  <img
                    :src="item.largeImageURL"
                    alt="image"
                    class="w-full object-contain rounded-4px h-calimg bg-ec cursor-pointer"
                  />
                  <div
                    v-if="OnlineSelectedImages.includes(item.largeImageURL)"
                    class="previewselect"
                  >
                    <feather-icon
                      icon="CheckIcon"
                      class="text-success flex font-semibold"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div v-else>No data found</div>
          </div>
        </div>
        <div v-else-if="currentStep === 2">
          <div class="flex w-full">
            <div class="w-5/12 overflow-y-auto height-left pr-3">
              <div class="">
                <!-- <div class="relative">
            <small class="fsize12 bg-white font-medium text-dark">Id</small>
            <el-input
              v-model="id"
              placeholder="Enter..."
              class="rounded-xl mt-2"
            />
          </div> -->
                <div class="relative">
                  <small class="fsize12 font-medium bg-white text-dark"
                    >Ai Prompt</small
                  >
                  <el-input
                    v-model="Prompt"
                    placeholder="Enter Event name in two words"
                    class="rounded-xl mt-2"
                  />
                  <vs-button
                    type="primary"
                    :class="[
                      isPromptDisabled ? 'bg-secondary' : 'bg-success',
                      'cursor-pointer',
                      'mt-3',
                      'px-8',
                      'py-3',
                    ]"
                    @click="GenerateHandP"
                    :disabled="isPromptDisabled"
                    >Send prompt</vs-button
                  >
                </div>
                <!-- <h3 class="fsize16 Add mb-0 Products">
                  Ai Credits: {{ ailimit }}
                </h3> -->
                <div class="relative mt-4">
                  <small class="fsize12 bg-white font-medium text-dark"
                    >Heading
                  </small>
                  <el-input
                    v-model="Heading"
                    type="textarea"
                    placeholder="Enter..."
                    class="rounded-xl mt-2"
                  />
                </div>

                <div class="relative mt-4">
                  <small class="fsize12 font-medium bg-white text-dark"
                    >Paragraph</small
                  >
                  <el-input
                    v-model="Paragraph"
                    type="textarea"
                    placeholder="Enter..."
                    class="rounded-xl mt-2"
                  />
                </div>

                <div class="relative mt-4">
                  <small class="fsize12 font-medium bg-white text-dark"
                    >Website</small
                  >
                  <el-input
                    v-model="Website"
                    type="text"
                    placeholder="Enter..."
                    class="rounded-xl mt-2"
                  />
                </div>
                <div class="relative mt-4">
                  <small class="fsize12 font-medium bg-white text-dark"
                    >Email</small
                  >
                  <el-input
                    v-model="Email"
                    type="text"
                    placeholder="Enter..."
                    class="rounded-xl mt-2"
                  />
                </div>
                <div class="relative mt-4">
                  <small class="fsize12 font-medium bg-white text-dark"
                    >Primary Color</small
                  >
                  <div class="relative">
                    <el-input
                      type="text"
                      id="name"
                      v-model="Primary"
                      required
                      placeholder="Hex or rgba"
                      class="inputstyle"
                    />

                    <input
                      type="color"
                      class="absolute top-0 right-0 m-2 w-10 h-7"
                      v-model="Primary"
                    />
                  </div>
                </div>
                <div class="relative mt-4">
                  <small class="fsize12 font-medium bg-white text-dark"
                    >Secondary Color</small
                  >
                  <div class="relative">
                    <el-input
                      type="text"
                      id="name"
                      v-model="Secondary"
                      required
                      placeholder="Hex or rgba"
                      class="inputstyle"
                    />

                    <input
                      type="color"
                      class="absolute top-0 right-0 m-2 w-10 h-7"
                      v-model="Secondary"
                    />
                  </div>
                </div>
              </div>
              <div>
                <div class="relative mt-4">
                  <small class="fsize12 font-medium bg-white text-dark"
                    >Heading Color</small
                  >
                  <div class="relative">
                    <el-input
                      type="text"
                      id="name"
                      v-model="text1Color"
                      required
                      placeholder="Hex or rgba"
                      class="inputstyle"
                    />

                    <input
                      type="color"
                      class="absolute top-0 right-0 m-2 w-10 h-7"
                      v-model="text1Color"
                    />
                  </div>
                </div>
              </div>
              <div>
                <div class="relative mt-4">
                  <small class="fsize12 font-medium bg-white text-dark"
                    >Paragraph Color</small
                  >
                  <div class="relative">
                    <el-input
                      type="text"
                      id="name"
                      v-model="text2Color"
                      required
                      placeholder="Hex or rgba"
                      class="inputstyle"
                    />

                    <input
                      type="color"
                      class="absolute top-0 right-0 m-2 w-10 h-7"
                      v-model="text2Color"
                    />
                  </div>
                </div>
              </div>
              <div>
                <div class="relative mt-4">
                  <small class="fsize12 font-medium bg-white text-dark"
                    >Website Color</small
                  >
                  <div class="relative">
                    <el-input
                      type="text"
                      id="name"
                      v-model="text3Color"
                      required
                      placeholder="Hex or rgba"
                      class="inputstyle"
                    />

                    <input
                      type="color"
                      class="absolute top-0 right-0 m-2 w-10 h-7"
                      v-model="text3Color"
                    />
                  </div>
                </div>
              </div>
              <div>
                <div class="relative mt-4">
                  <small class="fsize12 font-medium bg-white text-dark"
                    >Email Color</small
                  >
                  <div class="relative">
                    <el-input
                      type="text"
                      id="name"
                      v-model="text4Color"
                      required
                      placeholder="Hex or rgba"
                      class="inputstyle"
                    />

                    <input
                      type="color"
                      class="absolute top-0 right-0 m-2 w-10 h-7"
                      v-model="text4Color"
                    />
                  </div>
                </div>
              </div>
              <div class="relative mt-4">
                <small class="fsize12 font-medium bg-white text-dark"
                  >Heading font</small
                >
                <el-select
                  v-model="primaryFont"
                  placeholder="Title font"
                  class="w-full mt-2"
                  filterable
                >
                  <el-option
                    v-for="item in googleFontFamily"
                    :key="item"
                    :label="item"
                    :value="item"
                  >
                  </el-option>
                </el-select>
              </div>
              <div class="relative mt-4">
                <small class="fsize12 font-medium bg-white text-dark"
                  >Paragraph font</small
                >
                <el-select
                  v-model="ParagraphFont"
                  placeholder="Title font"
                  class="w-full mt-2"
                  filterable
                >
                  <el-option
                    v-for="item in googleFontFamily"
                    :key="item"
                    :label="item"
                    :value="item"
                  >
                  </el-option>
                </el-select>
              </div>

              <div class="mt-6">
                <small class="fsize12 bg-white font-medium text-dark"
                  >Select Media for Logo</small
                >
                <div class="grid grid-cols-3 gap-2 mt-4">
                  <!-- <div
              class="img_wrap"
              v-for="(item, index) in mediaCollection"
              :key="('item-', +index)"
              @click="LogoMedia = item"
              v-if="item.type != 'video'"
            >
              <div>
                <div>
                  <img
                    :src="item.link"
                    alt="image"
                    class="w-full object-cover rounded-4px h-72px cursor-pointer"
                  />
                </div>
              </div>

              <div class="previewselect" v-if="LogoMedia._id == item._id">
                <feather-icon
                  icon="CheckIcon"
                  svgClasses="w-8 h-8"
                  class="text-success font-semibold"
                />
              </div>
            </div> -->
                  <div v-if="LogoMedia._id">
                    <img
                      :src="LogoMedia._id ? url + '/' + LogoMedia.link : ''"
                      alt="image"
                      class="w-full object-cover rounded-4px"
                    />
                  </div>
                  <div
                    class="py-8 w-full flex justify-center items-center border-dashhed cursor-pointer rounded-lg"
                    @click="handleUploadMedia"
                  >
                    <feather-icon
                      icon="PlusIcon"
                      class="mr-1"
                      svgClasses="w-10 h-10"
                    />
                  </div>
                </div>
              </div>
              <div class="mt-6">
                <small class="fsize12 bg-white font-medium text-dark"
                  >Select Media for Image</small
                >
                <div class="grid grid-cols-3 gap-2 mt-4">
                  <!-- <div
              class="img_wrap"
              v-for="(item, index) in mediaCollection"
              :key="('item-', +index)"
              @click="ImageMedia = item"
              v-if="item.type != 'video'"
            >
              <div>
                <div>
                  <img
                    :src="item.link"
                    alt="image"
                    class="w-full object-cover rounded-4px h-72px cursor-pointer"
                  />
                </div>
              </div>

              <div class="previewselect" v-if="ImageMedia._id == item._id">
                <feather-icon
                  icon="CheckIcon"
                  svgClasses="w-8 h-8"
                  class="text-success font-semibold"
                />
              </div>
            </div> -->
                  <div v-if="ImageMedia._id">
                    <img
                      :src="ImageMedia._id ? url + '/' + ImageMedia.link : ''"
                      alt="image"
                      class="w-full object-cover rounded-4px"
                    />
                  </div>
                  <div
                    class="py-8 w-full flex justify-center items-center border-dashhed cursor-pointer rounded-lg"
                    @click="handleUploadImage"
                  >
                    <feather-icon
                      icon="PlusIcon"
                      class="mr-1"
                      svgClasses="w-10 h-10"
                    />
                  </div>
                </div>
              </div>

              <div class="mt-6">
                <small class="fsize12 bg-white font-medium text-dark"
                  >Select Layout</small
                >
                <div class="grid grid-cols-8 gap-2 mt-4">
                  <!-- eslint-disable-next-line vue/no-template-key -->
                  <!-- let the warning for the below v-if stay  -->
                  <div
                    class="img_wrap"
                    v-for="(item, index) in imgCollection"
                    :key="('item-', +index)"
                    @click="isShowImage = item"
                    v-show="item.Platform === Platform"
                  >
                    <div>
                      <svg
                        viewBox="0 0 1080 1080"
                        v-html="item.svg"
                        class="w-full object-cover rounded-4px h-72px cursor-pointer"
                      ></svg>

                      <div
                        v-if="isShowImage.svg == item.svg"
                        class="previewselect"
                      >
                        <feather-icon
                          icon="CheckIcon"
                          svgClasses="w-8 h-8"
                          class="text-success flex font-semibold"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="flex justify-end gap-4">
                <div>
                  <div>
                    <vs-button
                      type="primary"
                      class="bg-primary cursor-pointer mt-8 px-8 py-3"
                      @click="updateDetails"
                      >Create</vs-button
                    >
                  </div>
                </div>

                <vs-button
                  type="secondary"
                  class="cursor-pointer mt-8 px-8 py-3 bg-secondary"
                  @click="CancelEdit"
                  >Cancel</vs-button
                >
              </div>
            </div>
            <div v-if="isShowImage != ''" class="w-7/12">
              <div class="p-4 m-2 bg-fas height-left">
                <div class="canvas-parent">
                  <canvas id="my-canvas"></canvas>
                </div>
              </div>
            </div>
            <div v-else></div>
          </div>
        </div>

        <div class="flex gap-4 justify-start">
          <vs-button
            v-if="currentStep === 2"
            color="secondary"
            type="border"
            @click="prevStep"
            class="bg-secondary cursor-pointer mt-3 px-8 py-3"
            >Back</vs-button
          >
          <vs-button
            v-if="currentStep === 1"
            type="primary"
            class="bg-primary cursor-pointer mt-3 px-8 py-3"
            @click="nextStep"
            :is-disabled="EnableNext"
          >
            Next</vs-button
          >
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { BrandingGallerylogic } from "./BrandingGallerylogic";

export default {
  props: {
    isShowContentEdit: {
      type: Boolean,
      default: false,
    },
    parentIndex: {
      type: Number,
      default: null,
    },
    Platform: {
      type: String,
      default: null,
    },
    useMixinTypeA: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  name: "EditComp",
  mixins: [BrandingGallerylogic],

  watch: {
    async isShowContentEdit(newValue) {
      console.log("edittrue", newValue);
      if (newValue == true) {
        if (this.useMixinTypeA) {
          await this.ShowUpdate(this.parentIndex);
        } else {
          await this.getEventsCampaign();
          await this.ShowUpdateCampaign();
        }

        if (this.PostsAlreadyexsists) {
          if (this.currentStep < 2) {
            this.currentStep++;
          }
          this.PostsAlreadyexsists = false;
        } else {
          this.RequestToPixabay();
        }
      } else {
        this.$emit("DisableEdit");
      }
    },
    async Platform(newValue) {
      if (newValue === this.Platform) {
        console.log("ChangedPlatform", newValue, this.$options.name);
        this.Coords_image = [null, null];
        this.Coords_text = [null, null, null, null];
        this.rotation_image = [0, 0];

        this.isShowImage = eval(`this.${this.Templatemap[newValue]}`);
        this.FetchedLayout = null;
      }
    },
  },
};
</script>
